import { getApps, initializeApp, type FirebaseApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getStorage } from 'firebase/storage'

// Initialize Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyD4pILAtkctZxH99zpyi-leUrzEVhbxHK0',
  authDomain: 'yeheyshop-dev.firebaseapp.com',
  databaseURL: 'https://yeheyshop-dev.firebaseio.com',
  projectId: 'yeheyshop-dev',
  storageBucket: 'yeheyshop-dev.appspot.com',
  messagingSenderId: '142931570261',
  appId: '1:142931570261:web:4b8a5978b593eafa512edc',
  measurementId: 'G-0M3DBP909M',
}

// Hardcoded config for development - replace with env vars in production
const liveInventoryFirebaseConfig = {
  apiKey: 'AIzaSyAO0MHl8wrnYzZF5DD8PL6gweXVDa6aqYI',
  authDomain: 'live-inventory-4e953.firebaseapp.com',
  databaseURL: 'https://live-inventory-4e953-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'live-inventory-4e953',
  storageBucket: 'live-inventory-4e953.firebasestorage.app',
  messagingSenderId: '371969835214',
  appId: '1:371969835214:web:dcceb66507bfd8a573909f',
}

const dealzAppFirebaseConfig = {
  apiKey: "AIzaSyBFE-49C_WucNP3UVyPpG0s6yuikS1yFXQ",
  authDomain: "dealz-app-6c3e3.firebaseapp.com",
  databaseURL: "https://dealz-app-6c3e3-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "dealz-app-6c3e3",
  storageBucket: "dealz-app-6c3e3.firebasestorage.app",
  messagingSenderId: "471358793945",
  appId: "1:471358793945:web:54a8bfa15f8f546eb3f6c8",
  measurementId: "G-BCHL4YM3WK"
};

// Initialize main Firebase app
export const app = initializeApp(firebaseConfig)

// Initialize storage for main app
export const storage = getStorage(app)

// Initialize Live Inventory Firebase app
export const liveInventoryApp = initializeApp(liveInventoryFirebaseConfig, 'live-inventory')

export const dealzFirebaseApp = initializeApp(dealzAppFirebaseConfig, 'dealz-app')

// Initialize database with explicit URL
// export const liveInventoryDatabase = getDatabase(
//   liveInventoryApp,
//   liveInventoryFirebaseConfig.databaseURL
// )
